import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "transfer-attendance-application-container text-gray-333 mb-40" }
const _hoisted_2 = { class: "mb-8 font-size-24 font-bold" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_6 = { class: "mb-8" }
const _hoisted_7 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "mt-3 mr-4" }
const _hoisted_11 = { class: "mb-8" }
const _hoisted_12 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_DatePickerInput = _resolveComponent("DatePickerInput")
  const _component_InputTime = _resolveComponent("InputTime")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Table = _resolveComponent("Table")
  const _component_ReasonCreateApplication = _resolveComponent("ReasonCreateApplication")
  const _component_ReasonUpdateStatusApplication = _resolveComponent("ReasonUpdateStatusApplication")
  const _component_ApplicationApproveFlowDetail = _resolveComponent("ApplicationApproveFlowDetail")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BackPreviousPage, { onClick: _ctx.goToBack }, null, 8, ["onClick"]),
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('transferAttendanceApplication')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t('targetDate')) + "（" + _toDisplayString(_ctx.t('transitAttendanceDay')) + "） ", 1),
      _hoisted_5,
      _createVNode("div", null, _toDisplayString(_ctx.displayTargetDate(_ctx.targetDate)), 1)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('transferHoliday')), 1),
      _hoisted_8,
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.t('transferHoliday')), 1),
        _createVNode(_component_DatePickerInput, {
          disabled: _ctx.applicationFormId,
          validated: _ctx.validated,
          "error-server": _ctx.errorServer.transfer_date,
          errors: _ctx.errors.transfer_date,
          "onUpdate:errors": _cache[1] || (_cache[1] = ($event: any) => (_ctx.errors.transfer_date = $event)),
          required: "",
          modelValue: _ctx.transferAttendanceRequestParams.transfer_date,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.transferAttendanceRequestParams.transfer_date = $event))
        }, null, 8, ["disabled", "validated", "error-server", "errors", "modelValue"])
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, _toDisplayString(_ctx.t('workRecordApplication')), 1),
      _hoisted_13,
      _createVNode(_component_Table, {
        class: "text-center",
        headers: _ctx.transferAttendanceHeaders,
        data: _ctx.transferAttendanceRequestParams.exchange_workday_details
      }, {
        action: _withCtx(({ index }) => [
          _createVNode("span", {
            class: [[_ctx.applicationFormId ? 'pointer-events-none' : ''], "mr-1 cp-icon-plus cursor-pointer font-size-32 text-light-blue border-1 border-color-grey-dc rounded-50 hover:opacity-75"],
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addExchangeWorkdayDetails && _ctx.addExchangeWorkdayDetails(...args)))
          }, null, 2),
          (
              _ctx.transferAttendanceRequestParams.exchange_workday_details.length >
              1
            )
            ? (_openBlock(), _createBlock("span", {
                key: 0,
                class: [[_ctx.applicationFormId ? 'pointer-events-none' : ''], "cursor-pointer cp-icon-minus font-size-32 text-red-ff border-1 border-color-grey-dc rounded-50 hover:opacity-75"],
                onClick: ($event: any) => (_ctx.removeExchangeWorkdayDetails(index))
              }, null, 10, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        checkin_time: _withCtx(({ item, index }) => [
          _createVNode(_component_InputTime, {
            disabled: _ctx.applicationFormId,
            modelValue: item.checkin_time,
            "onUpdate:modelValue": ($event: any) => (item.checkin_time = $event),
            validated: _ctx.validated,
            "error-server": 
              _ctx.errorServer[`exchange_workday_details.${index}.checkin_time`]
            ,
            errors: 
              _ctx.errors[`exchange_workday_details.${index}.checkin_time`]
            ,
            "onUpdate:errors": ($event: any) => (
              _ctx.errors[`exchange_workday_details.${index}.checkin_time`]
             = $event),
            required: ""
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "validated", "error-server", "errors", "onUpdate:errors"])
        ]),
        checkout_time: _withCtx(({ item, index }) => [
          _createVNode(_component_InputTime, {
            disabled: _ctx.applicationFormId,
            modelValue: item.checkout_time,
            "onUpdate:modelValue": ($event: any) => (item.checkout_time = $event),
            validated: _ctx.validated,
            "error-server": 
              _ctx.errorServer[`exchange_workday_details.${index}.checkout_time`]
            ,
            errors: 
              _ctx.errors[`exchange_workday_details.${index}.checkout_time`]
            ,
            "onUpdate:errors": ($event: any) => (
              _ctx.errors[`exchange_workday_details.${index}.checkout_time`]
             = $event),
            required: ""
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "validated", "error-server", "errors", "onUpdate:errors"])
        ]),
        break_time: _withCtx(({ item, index }) => [
          _createVNode(_component_InputTime, {
            disabled: _ctx.applicationFormId,
            modelValue: item.break_time,
            "onUpdate:modelValue": ($event: any) => (item.break_time = $event),
            validated: _ctx.validated,
            "error-server": 
              _ctx.errorServer[`exchange_workday_details.${index}.break_time`]
            ,
            errors: 
              _ctx.errors[`exchange_workday_details.${index}.break_time`]
            ,
            "onUpdate:errors": ($event: any) => (
              _ctx.errors[`exchange_workday_details.${index}.break_time`]
             = $event),
            required: ""
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "validated", "error-server", "errors", "onUpdate:errors"])
        ]),
        checkin_unit: _withCtx(({ item, index }) => [
          _createVNode(_component_Dropdown, {
            disabled: _ctx.applicationFormId,
            modelValue: item.checkin_unit_id,
            "onUpdate:modelValue": ($event: any) => (item.checkin_unit_id = $event),
            placeholder: _ctx.t('placeholderSelect'),
            "options-select": _ctx.unitList,
            "item-text": "unit_name",
            "item-value": "unit_id",
            validated: _ctx.validated,
            "error-server": 
              _ctx.errorServer[`exchange_workday_details.${index}.checkin_unit_id`]
            ,
            errors: 
              _ctx.errors[`exchange_workday_details.${index}.checkin_unit_id`]
            ,
            "onUpdate:errors": ($event: any) => (
              _ctx.errors[`exchange_workday_details.${index}.checkin_unit_id`]
             = $event),
            required: ""
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "placeholder", "options-select", "validated", "error-server", "errors", "onUpdate:errors"])
        ]),
        _: 1
      }, 8, ["headers", "data"])
    ]),
    _createVNode(_component_ReasonCreateApplication, {
      "is-valid": !_ctx.isDisableSubmit,
      modelValue: _ctx.transferAttendanceRequestParams.application_reason,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.transferAttendanceRequestParams.application_reason = $event)),
      validated: _ctx.validated,
      errors: _ctx.errors.application_reason,
      "onUpdate:errors": _cache[5] || (_cache[5] = ($event: any) => (_ctx.errors.application_reason = $event)),
      "error-server": _ctx.errorServer.application_reason,
      onHandleCreateApplication: _ctx.submitPostTransferAttendanceApplication,
      onHandleCancel: _ctx.goToBack
    }, null, 8, ["is-valid", "modelValue", "validated", "errors", "error-server", "onHandleCreateApplication", "onHandleCancel"]),
    _createVNode(_component_ReasonUpdateStatusApplication, {
      status: _ctx.transferAttendanceApplicationDetail.application_status
    }, null, 8, ["status"]),
    _createVNode(_component_ApplicationApproveFlowDetail, {
      status: _ctx.transferAttendanceApplicationDetail.application_status,
      createdAt: _ctx.transferAttendanceApplicationDetail.created_at
    }, null, 8, ["status", "createdAt"])
  ]))
}